import { Routes } from '@angular/router';
import { HomeComponent } from './_components/home/home.component';
import { NewUploadComponent } from './_components/new-upload/new-upload.component';
import { CanDeactivateGuard } from './_services/guards/confirm-deactivate.guard';
import { MsalGuard } from '@azure/msal-angular';
import { LoginComponent } from './_components/login/login.component';
import { AdminComponent } from './_components/admin/admin.component';
import { PageNotFoundComponent } from './_components/errors/page-not-found/page-not-found.component';
import { PurchaseOrdersComponent } from './_components/purchase-orders/purchase-orders.component';
import { ProjectsComponent } from './_components/projects/projects.component';
import { DraftUploadComponent } from './_components/draft-upload/draft-upload.component';
import { NewSubmittalsComponent } from './_components/new-submittals/new-submittals.component';
import { NonAuthorizedComponent } from './_components/errors/non-authorized/non-authorized.component';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'home', component: HomeComponent, canActivate: [MsalGuard] },
  {
    path: 'projects', component: ProjectsComponent, canActivate: [MsalGuard], children: [
      { path: '', component: DraftUploadComponent, canActivate: [MsalGuard] },
      { path: ':projectid/:objectid', component: DraftUploadComponent, canActivate: [MsalGuard] }]
  },
  {
    path: 'orders', component: PurchaseOrdersComponent, canActivate: [MsalGuard], children: [
      { path: '', component: PurchaseOrdersComponent, canActivate: [MsalGuard] },
      { path: ':projectid', component: PurchaseOrdersComponent, canActivate: [MsalGuard] }]
  },
  {
    path: 'upload', component: NewUploadComponent, canDeactivate: [CanDeactivateGuard], canActivate: [MsalGuard], children: [
      { path: '', component: NewSubmittalsComponent, canActivate: [MsalGuard] },
      { path: ':projectid', component: NewSubmittalsComponent, canActivate: [MsalGuard] }]
  },
  { path: 'drafts', component: DraftUploadComponent, canDeactivate: [CanDeactivateGuard], canActivate: [MsalGuard] },
  { path: 'submittals', component: NewSubmittalsComponent, canDeactivate: [CanDeactivateGuard], canActivate: [MsalGuard] },
  { path: 'admin', component: AdminComponent, canActivate: [MsalGuard,] },
  { path: 'login', component: LoginComponent },
  { path: 'non-authorized', component: NonAuthorizedComponent },
  { path: '**', component: PageNotFoundComponent },
];
